<template>
<router-view name="invoiceIntegration" v-bind:key="$route.path"></router-view>
</template>
<script>
export default {
    name: "InvoiceIntegration"
}
</script>